import { render, staticRenderFns } from "./PersonalSetting.vue?vue&type=template&id=2ae29a5f&scoped=true&"
import script from "./PersonalSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalSetting.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSetting.vue?vue&type=style&index=0&id=2ae29a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae29a5f",
  null
  
)

export default component.exports